import React from 'react'
import classes from './styles.module.scss'
import _ from 'lodash'

const DICT = ['green', 'blue', 'red', 'purple', 'sky', 'yellow']

export default class Profile extends React.Component {
  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }
  render() {
    const { data, width = '40', className } = this.props // 头像 > 昵称首字母 > 手机号后2位 > 默认
    if (data.headLink) {
      return <img src={data.headLink} width={width} style={{ borderRadius: '50%' }} />
    }
    let defaultClassName = classes.componentsProfile
    defaultClassName += ` ${classes[DICT[Math.floor(Math.random() * 7)]]}`
    if (className) {
      defaultClassName += ` ${className}`
    }
    if (data.nickName) {
      return (
        <p className={defaultClassName}>
          <b>{_.startCase(data.nickName).slice(0, 1)}</b>
        </p>
      )
    }
    if (data.mobile) {
      return (
        <span>
          <p className={defaultClassName}>
            <b>{data.mobile.substr(-2)}</b>
          </p>
        </span>
      )
    }
    return <img src={require('./photo.png')} width={width} />
  }
}
